<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-21 15:38:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/components/ShopHeader/index.vue
-->
<template>
  <div class="text_left shop_name">
    <div class="font12 font_weight500 line_height_20 colo087">
      <img src="@/assets/order/icon_shop@2x.png" alt="" class="shop_icon" />
      <span class="name_name">{{ storeName }}</span>
    </div>
    <div
      v-if="switchOrderType === 1 || switchOrderType === 0"
      class="font12 font_weight400 line_height_16 colo038"
      @click="goExplain"
    >
      <img src="@/assets/common/icon_warn@2x.png" alt="" class="exp_icon" />
      <span class="exp_det">{{
        switchOrderType === 0 ? "发货说明" : "周期购配送规则"
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    storeName: {
      type: String,
      default: ""
    },
    showExp: {
      type: Boolean,
      default: true
    },
    switchOrderType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  methods: {
    goExplain() {
      this.$emit("goExplain");
    }
  }
};
</script>
<style lang="less" scoped>
.shop_name {
  background: #fff;
  padding: 19px 12px;
  font-size: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .shop_icon {
    width: 20px;
    vertical-align: middle;
    margin-right: 6px;
  }
  .name_name {
    vertical-align: middle;
  }
  .exp_icon {
    width: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }
  .exp_det {
    vertical-align: middle;
  }
}
</style>
